<template>
  <vue-js-modal
    v-if="agSwitch"
    :key="reload"
    id="agSwitchModal"
    class="agModal"
    name="agSwitchModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Switch {{agSwitch.shortname}}</h4>
        <h4 v-else class="agModal-title">Edit Switch {{agSwitch.shortname}}</h4>
      </template>

      <div class="agInputGroup agInputGroupCentered">
        <label>Source:</label>
        <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="agSwitch.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="agSwitch.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <hr />
      <div class="agInputGroup agInputGroupCentered">
        <label>Field:</label>
        <b-form-select 
          class="agLargeInput" 
          v-model="agSwitch.field" 
          :disabled="disableUI || isLoading"
          @change="field_change">
          <optgroup v-for="(field, key) in values" :key="key" :label="key">
            <option
              v-for="(option, index) in field"
              :key="index"
              :value="option.value"
            >{{option.text}}</option>
          </optgroup>
        </b-form-select>
      </div>
      <hr />
      <div v-for="(agCase, index) in agSwitch.cases" :key="index" class="agSwitchModal-case">
        <b-button
          v-if="index!=agSwitch.cases.length - 1"
          class="agSwitchModal-deleteCaseButton agDeleteButton agTextButton"
          :disabled="disableUI || isLoading"
          @click="deleteCaseButton_click(index)">
          Delete
        </b-button>
        <div class="agSwitchModal-caseLabel agInputGroup">
          <label v-if="index==agSwitch.cases.length - 1">Default:</label>
          <label v-else>Case {{index + 1}}:</label>
          <b-input :key="'cases-' + index + 1 + '-' + reloadCases" v-model="agCase.caseName" placeholder="Case label" maxlength=15></b-input>
        </div>
        <div v-if="index!=agSwitch.cases.length - 1" class="agInputGroup agInputSubGroup">
          <div class="agInputGroup agInputGroupInline">
            <b-input v-model="agSwitch.field.field" class="agInput agMediumInput" disabled></b-input>
          </div>
          <div class="agInputGroup agInputGroupInline">
            <b-form-select v-model="agCase.comparator" :options="comparators" :disabled="disableUI || isLoading"></b-form-select>
          </div>
          <div
            v-if="agCase.comparator != 'null' && agCase.comparator != 'notNull'"
            class="agInputGroup agInputGroupInline">
            <ag-input-select
              :key="'cases-' + index + '-' + reloadCases"
              :useSubInput="true"
              :inputModel="agCase.value.value"
              :selectModel="agCase.value.field"
              :workflow="workflow"
              :groups="values"
              :width="400"
              :disabled="disableUI || isLoading"
              @input_keyup="caseValueInput_keyup($event, agCase)"
              @select_change="caseValueSelect_change($event, agCase)">
            </ag-input-select>
          </div>
        </div>
        <div class="agInputGroup agInputGroupCentered">
          <b-table
            :key="'mods-' + index + '-' + reloadMods"
            class="agSwitchModal-modTable"
            :fields="modHeaders"
            :items="agCase.mods"
            :disabled="disableUI || isLoading"
            borderless
            outlined
            small>
            <template #head(modNo)>
              {{'No.'}}
            </template>
            <template #head(delete)>
              {{ '' }}
            </template>
            <template #cell(modNo)="data">
              <div class="agSwitchModal-modNo">{{ data.index + 1 }}</div>
            </template>
            <template #cell(field)="data">
              <b-form-select
                v-model="data.item.field"
                class="agSwitchModal-modField"
                :disabled="disableUI || isLoading"
                @change="modField_change($event, agCase, data.index)">
                <optgroup v-for="(field, key) in fields" :key="key" :label="key">
                  <option
                    v-for="(option, index) in field"
                    :key="index"
                    :value="option.value">
                    {{option.text}}
                  </option>
                </optgroup>
              </b-form-select>
            </template>
            <template #cell(operator)="data">
              <b-form-select 
                v-model="data.item.operator"               
                class="agSwitchModal-modOperator"
                :options="operators" 
                :disabled="disableUI || isLoading">
              </b-form-select>
            </template>
            <template #cell(value)="data">
              <div class="agSwitchModal-modValue">       
                <ag-input-select
                  :key="'modValues-' + index + '-' + reloadMods"
                  :useSubInput="true"
                  :inputModel="data.item.value.value"
                  :selectModel="data.item.value.field"
                  :workflow="workflow"
                  :groups="values"
                  :width="375"
                  :disabled="disableUI || isLoading"
                  @input_keyup="modValueInput_keyup($event, agCase, data.index)"
                  @select_change="modValueSelect_change($event, agCase, data.index)">
                </ag-input-select>
                <b-button
                  v-if="data.item.errors && data.item.errors.length > 0"
                  class="agSwitchModal-modErrorButton agImageButton"
                  :disabled="disableUI || isLoading"
                  @click="modErrorButton_click(data.item)">
                  <fa icon="exclamation-circle"/>
                </b-button>
              </div>
            </template>
            <template #cell(delete)="data">
              <b-button
                v-if="data.index != agCase.mods.length - 1"
                class="agSwitchModal-deleteModButton agDeleteButton agImageButton"
                :disabled="disableUI || isLoading"
                @click="deleteModButton_click(agCase, data.index)">
                <fa icon="times" />
              </b-button>
            </template>
          </b-table>
          <div class="agInputGroup agInputGroupCentered">
            <label>Destination:</label>
            <b-input type="text" :value="getNameForDest(agCase.dest)" class="agInput agExtraSmallInput" disabled></b-input>
          </div>
        </div>
        <hr/>
      </div>
      <b-button
        id="agSwitchModal-addCaseButton"
        class="agTextButton"
        :disabled="disableUI || isLoading"
        @click="addCaseButton_click">
        Add Case
      </b-button>

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      id="agSwitchModal-deleteModal"
      ref="deleteModal"
      class="agModal agSubModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Switch</h4>
      </template>
      Are you sure you want to delete switch
      <i>{{name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
        class="agModal-buttonRight"
        variant="danger"
        @click="confirmDeleteButton_click"
        >Delete</b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>


<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Vue from "vue";
import Util from "src/util/util";
import { EventBus } from "src/eventBus";

export default {
  name: "ag-switch-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean,
    validation: Object
  },
  components: {
    "ag-input-select": InputSelect
  },
  data() {
    return {
      agSwitch: null,
      reload: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      reloadCases: 0,
      reloadMods: 0,
      fields: {},
      values: {},
      modHeaders: ["modNo", "field", "operator", "value", "delete"],
      comparators: [
        { value: "equal", text: "equals" },
        { value: "notEqual", text: "does not equal" },
        { value: "contains", text: "contains" },
        { value: "notContains", text: "does not contain" },
        { value: "less", text: "less than" },
        { value: "lessEqual", text: "less than or equal to" },
        { value: "greaterEqual", text: "greater than or equal to" },
        { value: "greater", text: "greater than" },
        { value: "null", text: "is null or undefined" },
        { value: "notNull", text: "is not null or undefined" }
      ],
      operators: [
        { value: "set", text: "set" },
        { value: "append", text: "append" },
        { value: "prepend", text: "prepend" }
      ],
      modErrors: [],
    };
  },
  computed: {

    name() {
      if (this.agSwitch.name)
        return this.agSwitch.name;
      
      return this.agSwitch.shortname;
    },

    srcStr() {
      if (!this.agSwitch.src || this.agSwitch.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.agSwitch.src.length; i++) {
        var src = this.agSwitch.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    }
  },
  watch: {
    reloadCases() {
      this.reloadMods++;
    }
  },

  mounted() {},

  methods: {

    // UI Events

    async saveButton_click() {
      this.modalMessage = "";

      // remove last, empty row for each case
      for (var i = 0; i < this.agSwitch.cases.length; i++)
        this.agSwitch.cases[i].mods.pop();  
        
      var node = {
        object: this.agSwitch,
        type: "switch"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "switch",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
      // resinsert last rows in mods
      this.setMods();
    },

    cancelButton_click() {
      for (var i = 0; i < this.agSwitch.cases.length; i++)
        this.agSwitch.cases[i].mods.pop();
      this.hide();
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.agSwitch,
        type: "switch"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    addCaseButton_click() {
      var agCase = {
        comparator: "equal",
        value: {
          field: null,
          value: null
        },
        mods: [
          {
            field: null,
            child: null,
            operator: "set",
            value: {
              field: null,
              value: null
            }
          }
        ]
      };
      this.agSwitch.cases = Util.insertInArray(
        this.agSwitch.cases,
        this.agSwitch.cases.length - 1,
        agCase
      );
      this.reloadCases++;
    },

    deleteCaseButton_click(index) {
      this.agSwitch.cases = Util.removeFromArrayByIndex(
        this.agSwitch.cases,
        index
      );
      this.reloadCases++;
    },

    field_change(value) {
      if (value && value.field == "-- None --")
        this.agSwitch.field = null;
    },

    caseValueInput_keyup(value, agCase) {
      agCase.value.value = value;
      agCase.value.field = null;
    },

    caseValueSelect_change(value, agCase) {
      if (value.field == "-- None --")
        agCase.value.field = null;
      else
        agCase.value.field = value;
      agCase.value.value = null;
    },

    modField_change(value, agCase, index) {
      let mod = agCase.mods[index];
      if (value.field == "-- None --")
        mod.field= null;
      else
        mod.field = value;

      this.setMods();
    },

    modValueInput_keyup(value, agCase, index) {
      let mod = agCase.mods[index];
      mod.value.value = value;
      mod.value.field = null;
      this.setMods();
    },

    modValueSelect_change(value, agCase, index) {
      let mod = agCase.mods[index];
      if (value.field == "-- None --")
        mod.value.field = null;
      else
        mod.value.field = value;

      mod.value.value = null;
      this.setMods();
      this.reloadMods++;
    },

    modErrorButton_click(mod) {
      if(mod.errors) {
        let message = "";
        for(let i = 0; i < mod.errors.length; i++)
          message += `- ${mod.errors[i]}\n\n`;

        EventBus.$emit("showAlert", {
          title: `Mod Error`,
          message: message,
          type: "error"
        });
      }
    },

    deleteModButton_click(agCase, index) {
      agCase.mods = Util.removeFromArrayByIndex(agCase.mods, index);
      this.setMods();
      this.reloadMods++; // manually rerender mods tables there's UI using specific indexes
    },

    // emitted events

    // other
    async show() {
      await this.setSwitch();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agSwitchModal");
    },

    hide() {
      this.$modal.hide("agSwitchModal");
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      if (!this.agSwitch.field)
        this.agSwitch.field = {};

      this.setFields();
      this.setValues();
      this.setModErrors();
      this.setMods(); // to add empty row to end of all cases
      this.reloadCases++;
    },

    async setSwitch() {
      if(this.node && this.node.type == "switch") 
        this.agSwitch = this.workflow.switches.find((object) => object._id == this.node.object._id);
      else
        this.agSwitch = null;
    },

    setFields() {
      this.fields = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var outputFields = Util.getOutputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(outputFields);
      Object.assign(this.fields, optionGroups);
    },

    setValues() {
      this.values = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.values, optionGroups);
    },

    getNameForDest(dest) {
      if (dest) 
        return dest.shortname;
      return "";
    },

    setModErrors() {
      // pull any mod errors from workflow validation
      this.modErrors = [];
      if(this.validation) {
        let nodeValidation = this.validation.nodes.find((n) => n.shortname == this.agSwitch.shortname);
        if(nodeValidation && nodeValidation.errors) {
          for(let i = 0; i < nodeValidation.errors.length; i++) {
            let error = nodeValidation.errors[i];
            if(error.indexOf("row ") < 0)
              continue;

            let caseName = error.substring(0, error.indexOf(":"));
            error = error.replace(`${caseName}: `, "");
            let modNo = caseName.substring(caseName.indexOf("row "));
            modNo  = parseInt(modNo.replace("row ", ""));
            caseName = caseName.substring(0, caseName.indexOf(","));
            let caseIndex = this.agSwitch.cases.length - 1; // default to default cases' index (last)
            if(caseName.indexOf("Case") >= 0)
              caseIndex = parseInt(caseName.replace("Case ",  "")) - 1;
            
            // get this case's mod errors
            let caseErrors = this.modErrors[caseIndex];
            if(!caseErrors)
              caseErrors = {};

            // get mod errors for this specific mod
            let errors = caseErrors[modNo];
            if(!errors)
            errors = [];
            errors.push(error);
            caseErrors[modNo] = errors;

            // reassign case
            this.modErrors[caseIndex] = caseErrors;
          }
        }
      }
    },

    // ensures there is one empty row at the end of each mod table
    setMods() {
        for (let i = 0; i < this.agSwitch.cases.length; i++) {
          let agCase = this.agSwitch.cases[i];
          let caseErrors = this.modErrors[i];

          let modsToRemove = [];
          for(let j = 0; j < agCase.mods.length; j++) {
            let mod = agCase.mods[j];
            if(this.isModEmpty(mod))
              modsToRemove.push(mod);

            if(caseErrors && caseErrors[j+1]) {
              let modErrors = caseErrors[j+1];
              if(modErrors)
                mod.errors = modErrors;
            }
          }
          agCase.mods = agCase.mods.filter(a => modsToRemove.indexOf(a) < 0);


          // add empty row as last mod
           var newMod = {
            field: null,
            child: null,
            operator: "set",
            value: {
              field: null,
              value: null
            }
          };
          agCase.mods.push(newMod);
        }
    },

    isModEmpty(mod) {
      if(!mod.field && (!mod.value || (!mod.value.field && !mod.value.value)))
        return true;
      return false;
    },
  }
};
</script>


<style scoped lang="css">

#agSwitchModal-fieldInputs, #agSwitchModal-fieldInputs .agInputGroup {
  margin-bottom: 0px;
}

.agSwitchModal-case {
  position: relative;
}

.agSwitchModal-case hr {
  width: 85%;
  margin-left: 12.5%;
}

#agSwitchModal-addCaseButton {
  display: block;
  margin: 25px auto;
  font-size: 18px;
}

.agSwitchModal-deleteCaseButton {
  position: absolute;
  right: 0px;
  font-size: 16px;
}

.agSwitchModal-deleteModButton {
  margin: 5px;
  font-size: 20px;
}

.agSwitchModal-caseLabel {
  text-align: left;
  margin-bottom: 25px !important;
  font-weight: bold;
  color: gray;
}

.agSwitchModal-case .agInputGroup {
  margin-bottom: 10px;
}

.agSwitchModal-case table {
  margin: auto;
  margin-top: 10px;
  margin-bottom: 15px;
}

.agSwitchModal-modTable {
  text-align: center;
}

.agSwitchModal-modNo {
  position: relative;
  top: 7.5px;
}


.agSwitchModal-modField {
  width: 375px;
  display: inline-block;
}
.agSwitchModal-modOperator {
  width: 150px;
  display: inline-block;
}

.agSwitchModal-modValue {
  margin-left: 15px;
  text-align: left;
}

.agSwitchModal-modErrorButton {
    position: relative;
    top: 2.5px;
    margin-left: 10px;
    font-size: 20px;
    cursor: pointer;
    color: #DC3545;
}

.agSwitchModal-modError:hover {
    color: #C82333;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/SwitchModal.vue